import { Icon, Status } from '@teamsnap/snap-ui';
import * as React from 'react';
import { RegistrationOrderStatus } from './types';

type Props = {
  status: string;
  completedPayments?: number;
  totalPayments?: number;
};

const scheduleIconStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.WaitingForPayment,
  RegistrationOrderStatus.PartialPayment,
  RegistrationOrderStatus.Pending,
  RegistrationOrderStatus.PendingCashPayment,
  RegistrationOrderStatus.Unpaid,
];

const warningIconStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.Failed,
];

const rotateLeftIconStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.Chargeback,
  RegistrationOrderStatus.Refunded,
];

const runningWithErrorsIconStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.Overpaid,
];

const checkIconStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.Scheduled,
  RegistrationOrderStatus.Paid,
  RegistrationOrderStatus.InProgress,
];

const getIcon = (status: RegistrationOrderStatus) => {
  if (scheduleIconStatuses.includes(status)) {
    return <Icon name="schedule" size="s" />;
  } else if (rotateLeftIconStatuses.includes(status)) {
    return <Icon name="rotate_left" size="s" />;
  } else if (checkIconStatuses.includes(status)) {
    return <Icon name="check" size="s" />;
  } else if (warningIconStatuses.includes(status)) {
    return <Icon name="warning" size="s" />;
  } else if (runningWithErrorsIconStatuses.includes(status)) {
    return <Icon name="running_with_errors" size="s" />;
  }
};

const successColorStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.Paid,
  RegistrationOrderStatus.Scheduled,
  RegistrationOrderStatus.InProgress,
];

const negativeColorStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.Failed,
  RegistrationOrderStatus.Chargeback,
];

const warningColorStatuses: RegistrationOrderStatus[] = [
  RegistrationOrderStatus.WaitingForPayment,
  RegistrationOrderStatus.PartialPayment,
  RegistrationOrderStatus.Pending,
  RegistrationOrderStatus.PendingCashPayment,
  RegistrationOrderStatus.Overpaid,
  RegistrationOrderStatus.Refunded,
  RegistrationOrderStatus.Unpaid,
];

const getColor = (
  status: RegistrationOrderStatus
): 'success' | 'warning' | 'negative' | 'inactive' | 'info' => {
  if (successColorStatuses.includes(status)) {
    return 'success';
  } else if (negativeColorStatuses.includes(status)) {
    return 'negative';
  } else if (warningColorStatuses.includes(status)) {
    return 'warning';
  }
  return 'inactive';
};

export default function MemberRegistrationStatus({
  status,
  completedPayments,
  totalPayments,
}: Props) {
  const statusKey = Object.keys(RegistrationOrderStatus).find(
    (key) => RegistrationOrderStatus[key].toLowerCase() === status.toLowerCase()
  );

  const installmentText =
    [
      RegistrationOrderStatus.Scheduled,
      RegistrationOrderStatus.InProgress,
      RegistrationOrderStatus.Paid,
    ].includes(RegistrationOrderStatus[statusKey]) && totalPayments > 1
      ? ` (${completedPayments}/${totalPayments} complete)`
      : '';

  return (
    <Status
      data-testid="member-registration-status"
      state={getColor(RegistrationOrderStatus[statusKey])}
    >
      {getIcon(RegistrationOrderStatus[statusKey])}
      {statusKey ? RegistrationOrderStatus[statusKey] : 'Unknown'}
      {installmentText}
    </Status>
  );
}
